import React from 'react';
import { Box, useTheme } from '@mui/material';
import smallLogoDark from '../../assets/logo-dark-small.png';
import regularLogoDark from '../../assets/logo-dark.png';
import smallLogoLight from '../../assets/logo-light-small.png';
import regularLogoLight from '../../assets/logo-light.png';

interface LogoProps {
  width?: number;
  height?: number;
  variant?: 'small' | 'regular';
  forceDark?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  width,
  height,
  variant = 'regular',
  forceDark = false
}) => {
  const theme = useTheme();
  const isDarkMode = forceDark || theme.palette.mode === 'dark';

  const defaultDimensions = variant === 'small' 
    ? { width: 32, height: 32 }
    : { width: 100, height: 35 };

  const finalWidth = width || defaultDimensions.width;
  const finalHeight = height || defaultDimensions.height;

  const getLogoSrc = () => {
    if (variant === 'small') {
      return isDarkMode ? smallLogoDark : smallLogoLight;
    }
    return isDarkMode ? regularLogoDark : regularLogoLight;
  };

  return (
    <Box
      component="img"
      src={getLogoSrc()}
      alt="altifi Logo"
      sx={{
        width: finalWidth,
        height: finalHeight,
        display: 'inline-block',
        objectFit: 'contain'
      }}
    />
  );
};

export default Logo; 